var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCalendarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 28,
    viewBox: "0 0 25 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11432_1173)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.48214 1.3125C8.48214 0.585156 7.88504 0 7.14286 0C6.40067 0 5.80357 0.585156 5.80357 1.3125V3.5H3.57143C1.60156 3.5 0 5.06953 0 7V7.875V10.5V24.5C0 26.4305 1.60156 28 3.57143 28H21.4286C23.3984 28 25 26.4305 25 24.5V10.5V7.875V7C25 5.06953 23.3984 3.5 21.4286 3.5H19.1964V1.3125C19.1964 0.585156 18.5993 0 17.8571 0C17.115 0 16.5179 0.585156 16.5179 1.3125V3.5H8.48214V1.3125ZM2.67857 10.5H22.3214V24.5C22.3214 24.9813 21.9196 25.375 21.4286 25.375H3.57143C3.08036 25.375 2.67857 24.9813 2.67857 24.5V10.5Z",
    fill: "#084172"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11432_1173"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 28,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/calendarIcon.e3f9fb308db0d74c570899b1a3584b8b.svg";
export { ForwardRef as ReactComponent };